import { atom } from "jotai";
import { getAccountingDataAtom } from "@/store/accounting";
import { fetchApprovalsListAtom } from "@/store/approvals";
import { WORKSPACE_ROUTES } from "@/routes/workspace/utils/Workspace.router.utils";

export interface RefreshDeductionSourceQueuesOptions {
  refetch?: boolean;
}

const ACCOUNTING_ROUTE = WORKSPACE_ROUTES.ACCOUNTING;
const APPROVALS_ROUTE = WORKSPACE_ROUTES.APPROVALS;

const isCurrentRoute = (route: string): boolean => {
  if (globalThis.window === undefined) {
    return false;
  }

  const pathname = globalThis.window.location.pathname;
  return pathname === route || pathname.endsWith(route) || pathname.includes(`${route}/`);
};

/**
 * Refreshes the queue/list pages that can open the deduction drawer.
 * Each queue action preserves its own current pagination and filter state.
 */
export const refreshDeductionSourceQueuesAtom = atom(
  null,
  async (_get, set, options: RefreshDeductionSourceQueuesOptions = {}) => {
    const refetch = options.refetch ?? true;
    const refreshParams = { isLoading: false, isRefreshing: refetch };
    const refreshTasks: Promise<void>[] = [];

    if (isCurrentRoute(ACCOUNTING_ROUTE)) {
      refreshTasks.push(set(getAccountingDataAtom, refreshParams));
    }

    if (isCurrentRoute(APPROVALS_ROUTE)) {
      refreshTasks.push(set(fetchApprovalsListAtom, refreshParams));
    }

    await Promise.all(refreshTasks);
  }
);
